// @flow

import * as atypes from "src/constants/actionTypes";

export const grantOAuthAppPermisssions = () => ({
  type: atypes.OAUTH_APP_GRANT_PERMISSIONS_REQUEST
});
